import {useQuery} from '@tanstack/react-query';
import RegistryShoppingGraphQL from '../../services/RegistryShoppingGraphQL';

export default function useGetProductListHeroBySlug(slug) {
  return useQuery({
    queryKey: ['productListHero', slug],
    queryFn: () => RegistryShoppingGraphQL.getProductListHeroBySlug(slug),
    enabled: !!slug,
  });
}
